import type { BulkActionInputUploadPath } from '../types.js';

export class BulkActionInputUploadPathBuilder {
  public static buildPath(accountId: string, bulkActionId: string, fileName: string): `${BulkActionInputUploadPath}` {
    return `accounts/${accountId}/bulk-actions/${bulkActionId}/input/${fileName}`;
  }

  public static isBulkActionInputUploadPath(path: string): path is `${BulkActionInputUploadPath}` {
    const regex = /^accounts\/[^/]+\/bulk-actions\/[^/]+\/input\/.+$/;
    return regex.test(path);
  }
}
